"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgLargeCheck = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 69 68", size: size }, props),
        react_1.default.createElement("g", { clipPath: "url(#large-check_svg__clip0)" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M59.51 11.364L24.378 46.59 8.511 30.68c-1.814-1.817-4.987-1.817-6.8 0-1.814 1.819-1.814 5 0 6.819l19.266 19.318c.907.91 2.267 1.364 3.4 1.364 1.134 0 2.494-.455 3.4-1.364l38.534-38.636c1.813-1.818 1.813-5 0-6.818-2.04-1.819-4.987-1.819-6.8 0z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "large-check_svg__clip0" },
                react_1.default.createElement("path", { fill: "currentColor", d: "M0 0h68v68H0z", transform: "translate(.35)" })))));
};
exports.default = SvgLargeCheck;
//# sourceMappingURL=LargeCheck.js.map